import { Table } from "antd"
import { useEffect, useState } from "react"
import { Link } from "react-router-dom";
import FilterSample from "./FilterSample";
import { encrypt } from "../../../Utils/CryptoHelper";

const Sample = () => {

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [dataRFNumber, setDataRFNumber] = useState([]);

    useEffect(() => {
        if (data.length > 0) {
            setIsLoading(true);

            try {
                const grouped = data.reduce((acc, item) => {
                    const rfNumber = item.RFNumber || 'Unknown RF Number';
                    if (!acc[rfNumber]) {
                        acc[rfNumber] = [];
                    }
                    acc[rfNumber].push(item);
                    return acc;
                }, {});

                const formattedData = Object.entries(grouped).map(([rfNumber, samples], index) => ({
                    key: index + 1,
                    RFNumber: rfNumber,
                    Sample: samples,
                }));

                setDataRFNumber(formattedData);
            } catch (error) {
                console.error("Error grouping data:", error);
            } finally {
                setIsLoading(false);
            }
        } else {
            // Jika data kosong, pastikan table juga dikosongkan
            setDataRFNumber([]);
        }
    }, [data]);


    const columns = [
        {
            key: "key",
            title: "#",
            dataIndex: "key",
            fixed: "left",
            width: 80,
        },
        {
            key: "RFNumber",
            title: "RF Number",
            dataIndex: "RFNumber",
            sorter: (a, b) => a.RFNumber.localeCompare(b.RFNumber),
        },
    ];

    return (
        <div className="bg-white p-4 rounded-md">

            <FilterSample
                dataSource={(values) => setData(values)}
                isLoading={(values) => setIsLoading(values)}
            />

            <Table
                columns={columns}
                dataSource={dataRFNumber}
                loading={isLoading}
                scroll={{
                    x: 'max-content',
                }}
                expandable={{
                    expandedRowRender
                }}
                pagination={{
                    showTotal: (total) => `Total ${total} data`,
                }}
            />
        </div>
    )
}

export default Sample;


const expandedRowRender = (record) => {
    const Sample = record.Sample;

    const columnsSample = [
        {
            key: "OrderQuotation",
            title: "Order Quotation",
            dataIndex: "OrderQuotation",
            sorter: (a, b) => a.OrderQuotation.localeCompare(b.OrderQuotation),
            render: (value, record) => <Link to={`/dashboard/menuorder/order/${encodeURIComponent(encrypt(record.AccountId))}/${encodeURIComponent(encrypt(record.OrderCode))}`} className="text-second hover:text-second-200 font-medium">{value}</Link>
        },
        {
            key: "SampleNumber",
            title: "Sample Number",
            dataIndex: "SampleNumber",
            sorter: (a, b) => a.SampleNumber.localeCompare(b.SampleNumber),
            render: (value, record) => <Link to={`${encodeURIComponent(encrypt(record.AccountId))}/${encodeURIComponent(encrypt(record.SampleCode))}`} className="text-second hover:text-second-200 font-medium">{value}</Link>
        },
        {
            key: "SampleName",
            title: "Sample Name",
            dataIndex: "SampleName",
            sorter: (a, b) => a.SampleName.localeCompare(b.SampleName),
        },
        {
            key: "ServiceType",
            title: "Service Type",
            dataIndex: "ServiceType",
            sorter: (a, b) => a.ServiceType.localeCompare(b.ServiceType),
            render: (value) => (
                <p>{value ? value : '-'}</p>
            )
        },
        {
            key: "CustomerName",
            title: "Customer Name",
            dataIndex: "CustomerName",
            sorter: (a, b) => a.CustomerName.localeCompare(b.CustomerName),
        },
        {
            key: "ReceivedDate",
            title: "Received Date",
            dataIndex: "ReceivedDate",
            sorter: (a, b) => a.ReceivedDate.localeCompare(b.ReceivedDate),
        },
        {
            key: "COADueDate",
            title: "COA Due Date",
            dataIndex: "COADueDate",
            sorter: (a, b) => a.COADueDate.localeCompare(b.COADueDate),
            render: (date) => date === "1900-01-01" ? "-" : date
        },
    ]

    return (
        <Table
            columns={columnsSample}
            dataSource={Sample}
            scroll={{
                x: 'max-content',
            }}
        />
    )
}